export var ACCESS_TOKEN = 'Access-Token';
export var SIDEBAR_TYPE = 'SIDEBAR_TYPE';
export var DEFAULT_THEME = 'DEFAULT_THEME';
export var DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE';
export var DEFAULT_COLOR = 'DEFAULT_COLOR';
export var DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK';
export var DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER';
export var DEFAULT_FIXED_SIDEMENU = 'DEFAULT_FIXED_SIDEMENU';
export var DEFAULT_FIXED_HEADER_HIDDEN = 'DEFAULT_FIXED_HEADER_HIDDEN';
export var DEFAULT_CONTENT_WIDTH_TYPE = 'DEFAULT_CONTENT_WIDTH_TYPE';
export var DEFAULT_MULTI_PAGE = 'DEFAULT_MULTI_PAGE';
export var USER_NAME = 'Login_Username';
export var USER_INFO = 'Login_Userinfo';
export var USER_AUTH = 'LOGIN_USER_BUTTON_AUTH';
export var SYS_BUTTON_AUTH = 'SYS_BUTTON_AUTH';
export var CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
};